import '../styles/Hero.css';

function Hero({ title, image, compact }) {
  const style = image
    ? {
        backgroundImage:
          `linear-gradient(rgba(15, 117, 189, 0.82), rgba(11, 92, 150, 0.88)), url('${process.env.PUBLIC_URL}${image}')`
      }
    : undefined;

  return (
    <div className={`page-banner ${image ? 'has-image' : ''} ${compact ? 'compact' : ''}`} style={style}>
      <h1>{title}</h1>
    </div>
  );
}

export default Hero;
